import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowUp, Home } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const FloatingNav = () => {
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 200);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });
  const goHome = () => navigate('/');

  const btnStyle = {
    width: 46,
    height: 46,
    borderRadius: '50%',
    border: '1px solid rgba(184,134,11,0.35)',
    background: 'var(--bg-overlay, rgba(255,255,255,0.92))',
    backdropFilter: 'blur(16px)',
    boxShadow: '0 4px 20px rgba(0,0,0,0.12)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    color: 'var(--accent-gold-400)',
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: -20 }}
          transition={{ duration: 0.3, ease: [0.16, 1, 0.3, 1] }}
          style={{
            position: 'fixed',
            bottom: 28,
            left: 20,
            zIndex: 999,
            display: 'flex',
            flexDirection: 'column',
            gap: 10,
          }}
        >
          {/* Home */}
          <motion.button
            onClick={goHome}
            style={btnStyle}
            whileHover={{ scale: 1.1, y: -2, borderColor: 'var(--accent-gold-400)' }}
            whileTap={{ scale: 0.9 }}
            title="Ir para o Início"
          >
            <Home size={18} />
          </motion.button>

          {/* Scroll to top */}
          <motion.button
            onClick={scrollToTop}
            style={btnStyle}
            whileHover={{ scale: 1.1, y: -2, borderColor: 'var(--accent-gold-400)' }}
            whileTap={{ scale: 0.9 }}
            title="Voltar ao topo"
          >
            <ArrowUp size={18} />
          </motion.button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default FloatingNav;
